import { GET_SOCKET_PROGRESS } from "../actions/types";

const initialState = {
    progress: null,
    };

 const progress = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_SOCKET_PROGRESS:
            return {
                ...state,
                progress: payload,
            };
        
        default:
            return state;
    }
};

export default progress;